import {
  Button,
  Card,
  CardHeader,
  IconButton,
  TextField,
} from "@material-ui/core";
import { EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, update } from "firebase/database";
import React, { useState } from "react";
import { BeatLoader } from "react-spinners";

const Singlesettingitem = ({ option }) => {
  const [value, setValue] = useState(option?.value);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  function submitSetting() {
    const db = getDatabase();
    setLoading(true);
    update(ref(db, "Settings/"), {
      [option.property]: value,
    })
      .then((res) => {
        setLoading(false);
        setValue("");
        setShow(false);
      })
      .catch((err) => {
        setLoading(false);
        setError("Something Wrong!!");
      });
  }
  const changeHandler = (e) => {
    if (option.inputType === "number") {
      setValue(parseFloat(e.target.value));
    } else {
      setValue(e.target.value);
    }
  };

  return (
    <Card elevation={1}>
      <CardHeader
        //   avatar={<Person aria-label="recipe">R</Person>}
        action={
          <IconButton onClick={() => setShow(!show)} aria-label="settings">
            <EditOutlined />
          </IconButton>
        }
        title={option.name}
        subheader={
          (option?.value ? option.value : "Not Set") + " " + option.suffix
        }
      />
      {show && (
        <div style={{ marginLeft: "25px" }}>
          <TextField
            value={value}
            onChange={(e) => changeHandler(e)}
            label={option.name}
            variant="outlined"
            color="secondary"
            required
            type={option.inputType}
          />
          <br />
          <br />
          <p style={{ color: "red" }}>{error}</p>
          {loading ? (
            <BeatLoader loading={loading} />
          ) : (
            <Button
              onClick={() => submitSetting()}
              style={{ marginBottom: "10px" }}
              color="secondary"
              variant="outlined"
              type="submit"
              endIcon={<EditOutlined />}
            >
              Update
            </Button>
          )}
        </div>
      )}
    </Card>
  );
};

export default Singlesettingitem;
